exports.courseList = [
  'ART491', 'ART492',
  'BIB492',
  'BIO492', 'BIO493', 'BIO494',
  'BUS410', 'BUS492',
  'CDV492',
  'CHE491', 'CHE492',
  'COS492',
  'ECO491', 'ECO492',
  'EDU480', 'EDU481',
  'ENG490', 'ENG491', 'ENG492', 'ENG493',
  'FRE492',
  'HIS491', 'HIS492',
  'IDS491',
  'INS491', 'INS492',
  'MAT492',
  'MUS491', 'MUS492', 'MUS493',
  'PHI492',
  'PHY492',
  'POL491', 'POL492',
  'PSY492',
  'SOC490',
  'SPA492', 'SPM492',
  'THT491', 'THT492'
]

exports.deans = [
  { name: 'All Courses', code: 'ALL', subjects: [] },
  { name: 'Arts and Letters', code: 'ART', subjects: ['ART', 'ENG', 'MUS', 'THT'], deans: [{ pidm: '47752', name: 'Bill Tate', username: 'william.tate' }] },
  { name: 'Humanities', code: 'HUM', subjects: ['BIB', 'EDU', 'FRE', 'HIS', 'IDS', 'PHI', 'SPA'], deans: [{ pidm: '101942', name: 'John Wingard', username: 'john.wingard' }, { pidm: '371', name: 'Sarah Donaldson', username: 'sarah.donaldson' }] },
  { name: 'Social Sciences', code: 'SOC', subjects: ['BUS', 'CDV', 'ECO', 'POL', 'INS', 'SOC', 'SPM'], deans: [{ pidm: '2254', name: 'Cale Horne', username: 'cale.horne' }] },
  { name: 'Sciences', code: 'SCI', subjects: ['BIO', 'CHE', 'COS', 'MAT', 'PHY', 'PSY'], deans: [{ pidm: '1000299', name: 'Tim Morris', username: 'tim.morris' }] }
]
